const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const BlockingCondition = require('../../conditions/BlockingCondition');
const { logError } = require('../../logger');

const ShieldBlock = function(battleState) {
  this.handle = 'shield_block';
  this.physical = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function(actor, victim) {
    return actor.equipment.off_hand && actor.equipment.off_hand.type==='shield';
  };

  this.execute = function(actor, victim) {
    if (!actor || !actor.inPlay) {
      return { success: false };
    }

    try {
      var ability = BattleCalc.getEquippedAbility(actor, this.handle);

      const blocking = new BlockingCondition(
        actor,
        actor,
        battleState,
        ability.duration,
      );
      battleState.onUnitCondition(blocking);

      var result = { blocking };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim? victim.uid : null;
      result.allPieces = battleState.allPieces;

      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'ShieldBlock',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = ShieldBlock;
